module.exports = __webpack_public_path__ + "img/part_02.ff6ba96c.png";